import React from 'react';

import { darkenColor } from '../darkenColor';

interface IGantItemGradient {
    color: string;
    itemId: string;
    percentage: number;
}

const GantItemGradient: React.FC<IGantItemGradient> = ({ color, itemId, percentage }) => {
    const darkColor = darkenColor(color, 2000);

    return (
        <defs>
            <linearGradient id={`fillStatus-${itemId}`} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: darkColor, stopOpacity: 1 }} />
                <stop offset={`${percentage}%`} style={{ stopColor: darkColor, stopOpacity: 1 }} />
                <stop offset={`${percentage}%`} style={{ stopColor: color, stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: color, stopOpacity: 1 }} />
            </linearGradient>
        </defs>
    );
};

export default React.memo(GantItemGradient);
